import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as EmailValidator from "email-validator";
import Utils from "../../lib/utils";
import { getProducts as getProductsAction } from "../../redux/middleware/product";
import {
  createJob as createJobAction,
  getJob as getJobAction,
  updateJob as updateJobAction,
  getEmployerJobs as getEmployerJobsAction,
} from "../../redux/middleware/job";
import { getStoreProducts as getStoreProductsAction } from "../../redux/middleware/store";
import {
  getCountries,
  getRegions,
} from "../../redux/middleware/internationalize";
import { getProducts as getStoreProducts } from "../../redux/reducers/store";
import {
  getProducts,
  getProductsError,
  getProductsPending,
} from "../../redux/reducers/product";
import JobFormComponet from "./Components/JobForm";

export class JobForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: false,
      positionTypes: [],
      keywords: [],
      salary: 0,
    };
  }

  componentWillMount() {
    const {
      getJob,
      getStoreProducts,
      getCountries: getCountriesAction,
      match,
    } = this.props;
    const { slug } = match.params;
    this.setState({ jobLoaded: false });
    if (slug) {
      this.setState({ action: "edit" });
      getJob(slug);
    } else {
      this.initializeJob();
      getStoreProducts();
    }
    getCountriesAction();
  }

  componentDidMount() {
    if (document.activeElement !== document.body) document.activeElement.blur();
  }

  componentWillReceiveProps(nextProps) {
    const { job, storeProducts, countries, regions } = nextProps;
    const {
      updatePending,
      createPending,
      getEmployerJobs,
      notify,
      user,
      history,
      history: { goBack },
      getRegions: getRegionsAction,
    } = this.props;

    if (job && !regions.length) {
      this.setState({
        ...job,
        applyEmail: job.apply_email,
        url: job.apply_url,
        payRate: job.pay_rate,
        jobLength: job.job_length,
        telecomute: job.telecommuting_position,
        areaCode: job.area_code,
        jobLoaded: true,
        positionTypes: job.position_types.map((type) => type.name),
      });
    }
    if (storeProducts) {
      this.setState({ products: storeProducts });
      localStorage.setItem("p_data", JSON.stringify(storeProducts));
    }

    if (countries || regions) {
      this.setState({ countries, regions });
    }

    if(!this.props.job && job) {
      getRegionsAction(Utils.getCountryCode(countries, job.country))
    }

    if (!nextProps.updatePending && updatePending) {
      notify("success", "Job successfully updated");
      goBack();
    }
    if (!nextProps.createPending && createPending) {
      getEmployerJobs(user);
      notify("success", "Job successfully created");
      history.push({
        pathname: "/dashboard/jobs",
        jobs: nextProps.jobs,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", function () {}, true);
  }

  initializeJob = () => {
    const { productId, job } = Utils.getCart();
    this.setState({
      title: "",
      description: "",
      url: "",
      city: "",
      state: "",
      country: "",
      areaCode: "",
      zipcode: "",
      travel: false,
      action: "new",
      jobLoaded: true,
      products: [],
      showList: false,
      keywords: [],
      productId: productId || "",
      salary: 0,
      ...job,
      applyEmail: job ? job.apply_email : "",
      positionTypes: job ? job.position_types : "",
      payRate: job ? job.pay_rate : "",
      telecomute: job ? job.telecommuting_position : false,
      jobLength: job ? job.job_length : "",
      countries: [],
      regions: [],
    });
  };

  handleCancel = () => this.props.history.goBack();

  handleEmailUrl = (event) => {
    const emailvalue = event.target.value;
    const emailFlag = EmailValidator.validate(emailvalue);
    if (emailFlag) {
      this.state.applyEmail = emailvalue;
    } else {
      this.state.url = emailvalue;
    }
  };

  handleChange = (event) => {
    const { getRegions: getRegionsAction } = this.props;
    const { countries } = this.state;
    const { validate } = EmailValidator;
    if (event.editor) {
      const newContent = event.editor.getData();
      this.setState({ description: newContent });
    } else {
      const { name, value } = event.target;
      const emailFlag = validate(value);
      if (emailFlag) {
        this.state.applyEmail = value;
      } else {
        this.state.url = value;
      }
      this.setState({ [name]: value });
      const code = Utils.getCountryCode(countries, value);
      name === "country" && getRegionsAction(code);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { productId } = this.state;
    const { user, createJob } = this.props;
    const job = this.getJobParams();
    if (this.validate()) {
      this.hasJobCredits() && createJob(this.getJobParams(), user);
      productId && this.proceedToCheckout(productId, job);
    }
  };

  hasJobCredits = () => !!this.props.user?.job_credits.length;

  proceedToCheckout = (productId, job) => {
    const { quantity } = Utils.getProduct(productId);
    const { history } = this.props;

    const currentCart = Utils.getCart();
    const updateCart = {
      ...currentCart,
      job,
      productId,
      quantity,
    };
    Utils.setCart(updateCart);
    history.push("/employers/store/checkout");
  };

  handleUpdate = () => {
    const { updateJob } = this.props;
    const job = this.getJobParams();
    delete job.countries;
    this.validate() && updateJob(job);
  };

  getJobParams = () => {
    const {
      applyEmail,
      url,
      areaCode,
      payRate,
      jobLength,
      telecomute,
      positionTypes,
    } = this.state;
    return {
      ...this.state,
      apply_email: applyEmail,
      apply_url: url,
      area_code: areaCode,
      pay_rate: payRate,
      job_length: jobLength,
      telecommuting_position: telecomute,
      position_types: positionTypes,
    };
  };

  validate = () => {
    const errors = [];
    const { user, notify } = this.props;
    const {
      title,
      description,
      applyEmail,
      city,
      state,
      country,
      positionTypes,
      productId,
      payRate,
      jobLength,
      action,
    } = this.state;
    if (title === undefined || title === "") {
      errors.push({ field: "title", message: "Title can't be blank" });
    }
    if (description === undefined || description === "") {
      errors.push({
        field: "description",
        message: "Description can't be blank",
      });
    }
    if (applyEmail === undefined || applyEmail === "") {
      errors.push({
        field: "applyEmail",
        message: "Apply email can't be blank",
      });
    }

    if (city === undefined || city === "") {
      errors.push({ field: "city", message: "City can't be blank" });
    }
    if (state === undefined || state === "") {
      errors.push({ field: "state", message: "State can't be blank" });
    }
    if (country === undefined || country === "") {
      errors.push({ field: "country", message: "Country can't be blank" });
    }
    if (positionTypes === undefined || positionTypes === []) {
      errors.push({
        field: "positionTypes",
        message: "Position type can't be blank",
      });
    }
    if (
      (productId === undefined || productId === "") &&
      user &&
      action !== "edit" &&
      user.job_credits.length < 1
    ) {
      errors.push({ field: "productId", message: "Please choose a product" });
    }
    if (payRate < 0) {
      errors.push({
        field: "payRate",
        message: "Pay rate can not be negative",
      });
    }
    if (jobLength < 0) {
      errors.push({
        field: "joblength",
        message: "job length can not be negative",
      });
    }

    errors
      .map((error) => error.message)
      .forEach((error) => notify("error", error));
    return errors.length === 0;
  };

  handleItemClick = (position) => {
    const positionTypes = position && position.map((pos) => pos.value);
    this.setState({ positionTypes });
  };

  render() {
    const { productId, positionTypes, action } = this.state;
    const allPositionTypes = [
      { value: "Full Time", label: "Full Time" },
      { value: "Part Time", label: "Part Time" },
      { value: "Contract", label: "Contract" },
      { value: "Full Time - Remote", label: "Full Time - Remote" },
      { value: "Part Time - Remote", label: "Part Time - Remote" },
      { value: "Contract - Remote", label: "Contract - Remote" },
    ];
    const travelTypes = ["none", "0%-25%", "25%-50%", "50%-75%", "75%+"];
    const telecomute = ["No", "Yes"];
    const total = Utils.getProductTotal(productId);
    const { user, updatePending, createPending } = this.props;

    return (
      <JobFormComponet
        stateData={this.state}
        handleChange={this.handleChange}
        handleItemClick={this.handleItemClick}
        isNew={action === "new"}
        hasJobCredits={user && !!user.job_credits.length}
        handleSubmit={this.handleSubmit}
        handleCancel={this.handleCancel}
        handleUpdate={this.handleUpdate}
        total={total}
        allPositionTypes={allPositionTypes}
        positionTypes={positionTypes}
        travelTypes={travelTypes}
        user={user}
        telecomuteOptions={telecomute}
        createPending={createPending}
        updatePending={updatePending}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  job: state.job.job,
  updatePending: state.updateJob.pending,
  createPending: state.createJob.pending,
  jobs: state.getEmployersJobs.jobs,
  jobError: state.createJob.error,
  error: getProductsError(state),
  products: getProducts(state),
  pending: getProductsPending(state),
  storeProducts: getStoreProducts(state),
  regions: state.regions?.regions,
  countries: state.countries?.countries,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createJob: createJobAction,
      getProducts: getProductsAction,
      getJob: getJobAction,
      updateJob: updateJobAction,
      getStoreProducts: getStoreProductsAction,
      getEmployerJobs: getEmployerJobsAction,
      getCountries,
      getRegions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(JobForm);
